import Empty from 'constants/empty';

export default store => store.creditCard.ccTargeters || Empty.Object;
